
import { studyYearsActions } from './studyYears-slice';


export const fetchYears = (uiData) => {
    return async (dispath) => {
        try {
            let res = await fetch(uiData.studyYearsUrl)
            let data = await res.json();
            // console.log(data);
            dispath(studyYearsActions.init({ years: data }))
        }
        catch {

        }
    }
}